export default {
    // Shared with master builder
    selectedItem: null,
    draggedElement: null,
    currentGlobalConfig: {},
    isDragMode: false,
    // Specific for LP Builder
    parentSection: null,
    parentColumn: null,
    emptyHoveredColumnId: null,
    parentElement: null,
    elementChildSelected: null,
    currentHeaderId: null,
    currentFooterId: null,
}
